import {AxiosError, AxiosResponse} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {CompetitionForm} from '@eksab/pages/groups/[groupId]/competitions/create';
import type {Competition} from '@eksab/features/competition/types';

type CreateCompetitionParams = Omit<CompetitionForm, 'matches'> & {match_ids: number[]};

export function useCreateCompetitionMutation(
  options?: UseMutationOptions<{id: number; type: Competition['type']}, AxiosError, CreateCompetitionParams>,
) {
  return useMutation<{id: number; type: Competition['type']}, AxiosError, CreateCompetitionParams>(
    (params) =>
      api
        .post<CompetitionForm, AxiosResponse<{data: {id: number; type: Competition['type']}}>>('v2/competitions', {
          ...params,
          participants: {min: params.min, max: params.max},
        })
        .then((res) => res.data.data),
    {
      ...options,
      onSuccess: (...params) => {
        options?.onSuccess?.(...params);
      },
    },
  );
}
